var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _ellipse, _ellipse2, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyMarketingAutomation = function SvgImgEmptyMarketingAutomation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.962 11.127c-.07-.145-.175-.218-.315-.218h-2.762l.314-2.509c.035-.145-.07-.327-.21-.364a.326.326 0 0 0-.42.11l-3.496 4.363a.403.403 0 0 0-.035.4c.07.11.175.182.315.182h2.762l-.314 2.509c-.035.146.07.327.21.364.034.036.104.036.14.036.104 0 .21-.036.28-.146l3.496-4.363c.07-.11.105-.255.035-.364z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 25h35.498a9.5 9.5 0 1 1 .002 19H22",
    stroke: "#BDBDBD",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27h35.499a7.5 7.5 0 1 1 .001 15H22",
    stroke: "#BDBDBD",
    strokeOpacity: 0.3,
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 44H22.5C16.149 44 11 49.149 11 55.5S16.149 67 22.5 67H56",
    stroke: "#BDBDBD",
    strokeWidth: 1.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 42c-7.18 0-13 5.82-13 13v.5C9 62.956 15.044 69 22.5 69H56",
    stroke: "#BDBDBD",
    strokeOpacity: 0.3,
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 25,
    r: 2.6,
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 43,
    r: 2.6,
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 67,
    r: 2.6,
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 0.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 27,
    rx: 5,
    ry: 2,
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 69,
    rx: 5,
    ry: 2,
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 26s6-7.154 6-10.301C21 12.55 18.314 10 15 10s-6 2.551-6 5.699C9 18.846 15 26 15 26zm0-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    fill: "#BDBDBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.556 64.389s.68-.556 2.722-.556 3.403 1.112 5.444 1.112c2.042 0 2.723-.556 2.723-.556v-6.667s-.681.556-2.723.556c-2.041 0-3.402-1.111-5.444-1.111s-2.722.555-2.722.555v6.667z",
    fill: "#BDBDBD",
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.556 68.444v-4.666",
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyMarketingAutomation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img_empty_marketing_automation.06b1b8db2cd351332f3fa42cacbe8b23.svg";